import Model from '@/models/Model.js';

export default class RubricBank extends Model {
    static entity = 'rubric_banks';

    static modelName = 'RubricBank';

    static fields() {
        return {
            id: this.attr(null),
            course_template_id: this.attr(null),
            title: this.attr(null),
            activity_type_id: this.attr(null),

            ...super.fields(),

            tags: this.morphToMany('tags', 'taggables', 'tag_id', 'taggable_id', 'taggable_type'),
            groups: this.belongsToMany('groups', 'rubric_bank_group', 'rubric_bank_id', 'group_id'),
            courseTemplate: this.belongsTo('course_templates', 'course_template_id'),
            // rubricTemplates: this.hasMany('rubric_templates', 'rubric_templates_id'),
            activityType: this.belongsTo('activity_types', 'activity_type_id'),
        };
    }
}
